import React from 'react';
import { Stack, Tooltip } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { IconButton } from '../../../../components/ui';
import { useFeatureTheme } from '../../../../theme/hooks/useFeatureTheme';
import { ANALYTICS_COPY } from '../../constants/analyticsCopy';

export default function ReportCardActions({
  reportId,
  canManage = false,
  canDelete = false,
  onEdit,
  onDelete,
}) {
  const { semantic, typography } = useFeatureTheme();

  if ((!canManage && !canDelete) || !reportId) {
    return null;
  }

  const stop = (event) => {
    event.stopPropagation();
  };

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      {canManage ? (
        <Tooltip title={ANALYTICS_COPY.editReport}>
          <IconButton
            size="sm"
            variant="ghost"
            aria-label={ANALYTICS_COPY.editReportAria}
            onClick={(event) => {
              stop(event);
              onEdit?.(reportId);
            }}
          >
            <EditOutlinedIcon sx={{ fontSize: typography.fontSizeLg }} />
          </IconButton>
        </Tooltip>
      ) : null}
      {canDelete ? (
        <Tooltip title={ANALYTICS_COPY.deleteReport}>
          <IconButton
            size="sm"
            variant="ghost"
            aria-label={ANALYTICS_COPY.deleteReportAria}
            onClick={(event) => {
              stop(event);
              onDelete?.(reportId);
            }}
            sx={{
              color: semantic.text.secondary,
              '&:hover:not(:disabled)': {
                color: semantic.states.danger,
                bgcolor: semantic.states.dangerSoft,
              },
            }}
          >
            <DeleteOutlineIcon sx={{ fontSize: typography.fontSizeLg }} />
          </IconButton>
        </Tooltip>
      ) : null}
    </Stack>
  );
}
